/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import {
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  Table,
  Button
} from 'reactstrap';

import ModalConfirmation from 'components/Modal/ConfirmationModal';
import Loader from 'components/Loader';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import Pagination from 'components/Pagination';

import ProtocolProcessService from '../service';

import { useListProtocolProcesses } from '../hooks/useListProtocolProcesses';
import { toast } from 'react-toastify';

const ProtocolProcessList = () => {
  const [activePage, setActivePage] = useState(1);
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const [idProtocolProcess, setIdProtocolProcess] = useState(null);

  const history = useHistory();

  const {
    getProtocolProcesses,
    protocolProcesses,
    totalProtocolProcesses,
    isLoadingProtocolProcesses
  } = useListProtocolProcesses();

  useEffect(() => {
    getProtocolProcesses();
  }, []);

  const handlePageChange = (newPage) => {
    setActivePage(newPage);
    getProtocolProcesses(newPage);
  };

  const handleEditButtonClick = useCallback((protocolProcessId) => {
    history.push(`/admin/crm/protocolProcess/form/${protocolProcessId}`);
  });

  const handleDeleteProtocolProcess = useCallback((id) => {
    ProtocolProcessService.delete(id)
      .then(() => {
        toast.success('Processo de atendimento deletado com sucesso!');
      })
      .catch((err) => {
        const message =
          err?.response?.data?.message ||
          'Erro ao deletar o processo de atendimento';
        toast.error(message);
      })
      .finally(() => {
        setOpenModalConfirmation(false);
        getProtocolProcesses(1);
      });
  }, []);

  const controlDeleteAudio = (id) => {
    setIdProtocolProcess(id);
    setOpenModalConfirmation(true);
  };

  return (
    <>
      <SimpleHeader
        setCreate="/admin/crm/protocolProcess/form"
        name="Form validation"
        parentName="Forms"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">Processos de Atendimento</h3>
                </CardHeader>
                <CardBody>
                  {isLoadingProtocolProcesses ? (
                    <div className="col-12">
                      <Row className="justify-content-md-center">
                        <Loader />
                      </Row>
                    </div>
                  ) : (
                    <Table hover={true} striped>
                      <thead>
                        <tr>
                          <th>Nome</th>
                          <th className="text-center">Editar</th>
                          <th className="text-center">Excluir</th>
                        </tr>
                      </thead>
                      <tbody>
                        {protocolProcesses &&
                          protocolProcesses.map((protocolProcess) => {
                            return (
                              <tr key={protocolProcess.id}>
                                <td>{protocolProcess.name}</td>
                                <td width="10%" className="text-center">
                                  <Button
                                    size="sm"
                                    color="info"
                                    onClick={() =>
                                      handleEditButtonClick(protocolProcess.id)
                                    }
                                  >
                                    <li className="fas fa-user-edit"></li>
                                  </Button>
                                </td>
                                <td width="10%" className="text-center">
                                  <Button
                                    size="sm"
                                    color="danger"
                                    onClick={() =>
                                      controlDeleteAudio(protocolProcess.id)
                                    }
                                  >
                                    <li className="fas fa-trash"></li>
                                  </Button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </Table>
                  )}
                </CardBody>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={totalProtocolProcesses}
                  onChange={handlePageChange.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>

      <ModalConfirmation
        isModalOpen={openModalConfirmation}
        onModalToggle={setOpenModalConfirmation}
        unmountOnClose={true}
        idResource={idProtocolProcess}
        deleteResource={handleDeleteProtocolProcess}
        message={'Tem certeza que deseja excluir o processo?'}
      />
    </>
  );
};

export default ProtocolProcessList;
